"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetEventBusInitializer = exports.EventBusInitializer = exports.EventBusInitializationError = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const eventBusManager_1 = require("./eventBusManager");
const EVENT_BUS_ERROR = 'EventBus initialization error';
class EventBusInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(EVENT_BUS_ERROR, message);
    }
}
exports.EventBusInitializationError = EventBusInitializationError;
class EventBusInitializer extends web_ui_framework_1.Initializer {
    constructor() {
        super(...arguments);
        this.launch = () => {
            try {
                (0, eventBusManager_1.initGlobalEventBus)();
                return Promise.resolve();
            }
            catch (e) {
                throw new EventBusInitializationError(e);
            }
        };
    }
}
exports.EventBusInitializer = EventBusInitializer;
class SetEventBusInitializer extends web_ui_framework_1.Initializer {
    constructor(eventBus) {
        super();
        this.launch = () => {
            try {
                (0, eventBusManager_1.setGlobalEventBus)(this.eventBus);
                return Promise.resolve();
            }
            catch (e) {
                throw new EventBusInitializationError(e);
            }
        };
        this.eventBus = eventBus;
    }
}
exports.SetEventBusInitializer = SetEventBusInitializer;
//# sourceMappingURL=eventBus.initializer.js.map